export default __webpack_public_path__ + "static/media/Refined Philtre of Intellect.4966be53.jpg";